"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIWorkOrderChecklistEntity = void 0;
const iwork_order_checklist_item_entity_1 = require("./iwork-order-checklist-item-entity");
function parseIWorkOrderChecklistEntity(data) {
    if (data.items !== null && typeof data.items === 'object')
        data.items = data.items.map((x) => (0, iwork_order_checklist_item_entity_1.parseIWorkOrderChecklistItemEntity)(x));
    return data;
}
exports.parseIWorkOrderChecklistEntity = parseIWorkOrderChecklistEntity;
